import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class LocalMagicPageItem extends cc.Component {

    @property(cc.Node)
    defaultNode : cc.Node = null;
    @property(cc.Node)
    chooseNode : cc.Node = null;
    @property
    pageIndex : number = 0;

    onLoad () {
        O1HD.on("pageItem.chooseIndex",this.chooseIndex ,this );
        // console.log(this.defaultNode);
    }

    start () {

    }

    chooseIndex( index : number ){
        if ( this.node ) {
            if ( index == this.pageIndex ) {
                this.defaultNode.active = false;
                this.chooseNode.active = true;
            }else{
                this.defaultNode.active = true;
                this.chooseNode.active = false;
            }
        }
    }

}
